// extracted by mini-css-extract-plugin
export var buttonContent = "_48-0";
export var centered = "_48-1";
export var centeredFlex = "_48-2";
export var errorText = "_48-3";
export var icon = "_48-4";
export var iconButtonContent = "_48-5";
export var monospace = "_48-6";
export var padded = "_48-7";